import { useEffect, useState } from "react";
import styled from "styled-components";
import { Loading } from "react-vant";
import Select from "../../components/Select";

import { LEVELS_SELECT_OPTIONS } from "../../utils/constants";
import ECodeCards from "../../components/ECards/CodeIndex";
import useBag from "./hook";
import useGlobal from "../../hooks/useGlobal";

import { useIntl } from "react-intl";
export default function Bag() {
  const [loading, setLoading] = useState(true);
  const [searchData, setSearchData] = useState({
    equip_type: "",
    card_level: "",
    equip_level: "",
  });

  const [list, setList] = useState([])
  const {  showEqiupModal } =
    useBag();
  const {  userInfo,getAllInfo,canPlay } = useGlobal();
  const intl = useIntl();
  useEffect(() =>{
    if(userInfo) {
      setLoading(false)
      filterData()
    }
  },[userInfo,searchData])
  useEffect(() => {
    if (canPlay) {
      getAllInfo();
    }
  }, [canPlay]);

  const filterData = () => {
      let l = userInfo.equips
      if(searchData.equip_level){
        l = userInfo.equips.filter(e => e.level === searchData.equip_level)
      }
      setList(l)
  }
  return (
    <Wrapper>
      <FilterRow>
        <>
          <Select
            key={"equip"}
            list={LEVELS_SELECT_OPTIONS}
            defaultSelected={""}
            onConfirm={(val, item) => {
              setSearchData({
                equip_type: "",
                card_level: "",
                equip_level: val[0],
              });
            }}
          />
          {/* {userInfo ? (
              <Btn
                className="primary_btn"
                onClick={() => {
                  composeFn();
                }}
              >
                {intl.formatMessage({
                  id: "components.to_compose",
                  defaultMessage: "去合成",
                })}
              </Btn>
            ) : null} */}
        </>
      </FilterRow>
      <ScrollWrapper>
        {loading ? (
          <Loading style={{ marginTop: "20vw" }} size="2.4rem" vertical>
            {intl.formatMessage({
              id: "common.loading",
              defaultMessage: "加載中...",
            })}
          </Loading>
        ) : (
          <ECodeCards
            list={list}
            onClick={(item) => {
              showEqiupModal(item);
            }}
            // onLongClick={(item) => {
            //   longClickEqiup(item);
            // }}
          />
        )}
      </ScrollWrapper>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  padding: 0 1.0rem;
`;
const ScrollWrapper = styled.div`
  height: calc(100vh - 16.1rem);
  overflow-y: auto;
  overflow-x: hidden;
  padding-bottom: 7.0rem;
  box-sizing: border-box;
`;

const FilterRow = styled.div`
  /* margin: 1.2rem 0 1.0rem;
  display: flex;
  justify-content: space-between;
  align-items: center; */
  margin-bottom:2.0rem;
  text-align: right;
`;

const Btn = styled.button`
  font-weight: 500;
  font-size: 1.3rem;
  line-height: 1.3rem;
  padding: .8rem 2.9rem !important;
`;
